module.exports = __webpack_public_path__ + "img/心电图.ae48451e.png";